export const actionTypes = {
	SetChallenges: '[Challenges] SetChallenges',
	AddChallenge: '[Challenges] AddChallenge',
	UpdateChallenge: '[Challenges] UpdateChallenge',
	DeleteChallenge: '[Challenges] DeleteChallenge',
};

export const initialState = {
	challenges: [],
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SetChallenges:
			return {
				...state,
				challenges: action.payload,
			};
		case actionTypes.AddChallenge:
			return {
				...state,
				challenges: [action.payload, ...state.challenges],
			};
		case actionTypes.UpdateChallenge:
			return {
				...state,
				challenges: state.challenges.map(c =>
					c._id === action.payload._id ? { ...c, ...action.payload } : c,
				),
			};
		case actionTypes.DeleteChallenge:
			return {
				...state,
				challenges: state.challenges.filter(c => c._id !== action.payload._id),
			};
		default:
			return state;
	}
};

export const actions = {
	setChallenges: payload => ({ type: actionTypes.SetChallenges, payload }),
	addChallenge: payload => ({ type: actionTypes.AddChallenge, payload }),
	updateChallenge: payload => ({ type: actionTypes.UpdateChallenge, payload }),
	deleteChallenge: payload => ({ type: actionTypes.DeleteChallenge, payload }),
};
